import { render } from "./InputEmail.vue?vue&type=template&id=b65ed544&scoped=true"
import script from "./InputEmail.vue?vue&type=script&lang=ts"
export * from "./InputEmail.vue?vue&type=script&lang=ts"

import "./InputEmail.vue?vue&type=style&index=0&id=b65ed544&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b65ed544"

export default script